import * as React from 'react'
import styled from 'styled-components'
import {ConfiguratorBox, HighlightInBox} from 'src/components/containers/configurator/ConfiguratorBox'
import Link from 'src/components/atoms/input/buttons/Link'
import {inject, observer} from 'mobx-react'
import {StoreProps} from 'src/stores'
import Loading from 'src/components/atoms/Loading'

interface Props extends StoreProps {
  window?: any
}

interface State {
  loading: boolean
}

@inject('confStore')
@observer
export default class Confirmation extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { loading: true }
  }

  componentDidMount() {
    setTimeout(() => this.setState({ loading: false }), 1500)
  }

  loading = () => {
    return (
      <ConfiguratorBox title='Lädt ...'>
        <Loading />
      </ConfiguratorBox>
    )
  }

  formatCurrentDate = () => {
    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month =
      currentDate.getMonth() < 10
        ? `${0}${currentDate.getMonth() + 1}`
        : currentDate.getMonth() + 1
    const day =
      currentDate.getDate() < 10
        ? `${0}${currentDate.getDate()}`
        : currentDate.getDate()
    return `${year}-${month}-${day}`
  }

  confirmation = () => {
    const { confStore } = this.props
    const mandateFormUrl = process.env.REACT_APP_MANDATE_URL
    const offer = confStore.getOffer
    const currentDate = this.formatCurrentDate()
    const greeting =
      offer.contactDetails.greeting === 'MR'
        ? 'Sehr geehrter Herr '
        : 'Sehr geehrte Frau '
    return (
      <ConfiguratorBox title='Vielen Dank!'>
        <p>
          {greeting} {offer.contactDetails.lastName},
        </p>
        <p>
          vielen Dank, dass Sie uns Ihr Vetrauen für die Organisation der
          Bestattung schenken! Wir werden Sie nun Schritt für Schritt begleiten
          und zu jeder Tages- und Nachtzeit für Sie persönlich da sein.
        </p>
        <p>
          Um die Bestattung vollumfänglich für Sie organisieren zu können und
          Sie in allen Formalitäten (z.B. Kranken&shy;häusern, Friedhöfen, etc.)
          vertreten zu können, bitten wir Sie um die Erteilung einer
          Bestattungs&shy;vollmacht.
        </p>
        <p>
          Klicken Sie ganz einfach hier unten, um zum Vollmachtsformular zu
          gelangen und uns Ihre Bestattungsvollmacht direkt online zu erteilen.
        </p>
        <Link to={mandateFormUrl + offer.uuid} target='_blank'>
          Zum Vollmachtsformular
        </Link>
        <SmallDisclaimerP>
          Alternativ können Sie{' '}
          <a
            href='https://www.benu.at/wp-content/uploads/Benu-Bestattungsvollmacht.pdf'
            target='_blank'>
            {' '}
            hier{' '}
          </a>
          das Formular für die Bestattungsvollmacht herunterladen. Nach dem
          Ausfüllen und Unterschreiben schicken Sie die Vollmacht bitte an per
          Mail an
          <a href='mailto:kontakt@benu.at'> kontakt@benu.at </a> oder per
          Whatsapp an
          <a
            href={`https://wa.me/43800884404?text=Meine%20Vollmacht%20zum%20Angebot%20"${offer.orderId}"`}
            target='_blank'>
            {' '}
            0800 88 44 04.{' '}
          </a>
        </SmallDisclaimerP>
        <HighlightInBox>
          <p>
            <strong>Alles erledigt?</strong>
          </p>
          <CustomP>
            Kehren Sie zurück zu Ihrer{' '}
            <a href={`/planung/detailplanung/${offer.uuid}`}>Angebotsseite</a>, um sich
            nochmal einen Überblick zu verschaffen.
          </CustomP>
          <CustomP>
            Oder informieren Sie sich in unserem Ratgeber zu weiteren Themen wie{' '}
            <a
              href='https://www.benu.at/ratgeber/bestattung/erinnerungsstuecke/'
              target='_blank'>
              Erinnerungsschmuck
            </a>
            ,{' '}
            <a href='https://www.benu.at/ratgeber/grab/' target='_blank'>
              Grabstein & Grabpflege
            </a>{' '}
            oder{' '}
            <a href='https://www.benu.at/ratgeber/erben/' target='_blank'>
              Verlassenschaft
            </a>
            . Gerne beraten wir Sie auch zu diesen Themen.
          </CustomP>
          <ToRatgeber to='/ratgeber/' target='_blank' light>
            Zum Ratgeber
          </ToRatgeber>
        </HighlightInBox>
        <TrustedShopsDiv id='trustedShopsCheckout'>
          <span id='tsCheckoutOrderNr'>{offer.orderId}</span>
          <span id='tsCheckoutBuyerEmail'>{offer.contactDetails.email}</span>
          <span id='tsCheckoutOrderAmount'>
            {offer.totalAmount.amount / 100}
          </span>
          <span id='tsCheckoutOrderCurrency'>EUR</span>
          <span id='tsCheckoutOrderPaymentType'>KAUF AUF RECHNUNG</span>
          <span id='tsCheckoutOrderEstDeliveryDate'>{currentDate}</span>
        </TrustedShopsDiv>
      </ConfiguratorBox>
    )
  }

  render() {
    const { loading } = this.state
    return loading ? this.loading() : this.confirmation()
  }
}

const CustomP = styled.p`
  a {
    color: unset;
    text-decoration: underline;
    &:hover {
      color: unset;
    }
  }
`

const TrustedShopsDiv = styled.div`
  display: none;
`

const SmallDisclaimerP = styled.p`
  font-size: 12px;
  text-decoration: italic;
  a {
    color: unset;
    text-decoration: underline;
    &:hover {
      color: unset;
    }
  }
`

const ToRatgeber = styled(Link)`
  margin: 7.5px auto;
  padding: 7.5px;
`



// WEBPACK FOOTER //
// ./src/components/organisms/checkout/Confirmation.tsx